




































import { Component, Vue } from "vue-property-decorator";

@Component
export default class SelectAuthorizationFlow extends Vue {
    // methods
    open() {
        this.$bvModal.show("modal-select-template-type");
    }

    selectFlow(type: string) {
        if (type === "ropcFlow") this.$router.push({ name: "createRopcAuthorization" });
        if (type === "authorizationCodeFlow") this.$router.push({ name: "createAcfAuthorization" });
        if (type === "clientCredentialFlow") this.$router.push({ name: "createCcfAuthorization" });
    }
}
